

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import AnonJobWorkerOfferWorkerAcceptanceReply from '@/models/AnonJobWorkers/AnonJobWorkerOfferWorkerAcceptanceReply';
import PageNames from '@/router/PageNames';
import ListUtils from '@/lib/listUtils';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AppModule } from '@/store/modules/app';

@Component({
    name: 'WorkerOfferAcceptanceAcceptDecline'
})
export default class extends GiganautVueDialog {

  public dialog = false;
  public request: AnonJobWorkerOfferWorkerAcceptanceReply = new AnonJobWorkerOfferWorkerAcceptanceReply();

  get allowDeclineOffer () {
      return WorkerAnonModule.offerAcceptance.allowDeclineOffer;
  }

  get offerAcceptance() {
    return WorkerAnonModule.offerAcceptance;
  }

  get buttonLabel() {
    if (this.allowDeclineOffer) {
      return "ACCEPT/DECLINE";
    } else {
      return "ACCEPT";
    }    
  }

  get dialogTitle() {
    if (this.allowDeclineOffer) {
      return "Accept or Decline Offer";
    } else {
      return "Accept Offer";
    }    
  }

  get submitButtonLabel() {
    if (this.allowDeclineOffer) {
      return "SUBMIT";
    } else {
      return "ACCEPT";
    }   
  }
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (!this.allowDeclineOffer) {
        //Automatically tick the hidden tickbox
        this.request.accepted = true;
      }
    }
  }

  get loading() {
    return WorkerAnonModule.loadingDialog;
  }

  get declinedReasons() {
    return ListUtils.jobWorkerOfferWorkerDeclinedReasons();
  }
	  
  async submit() { 
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    await WorkerAnonModule.offerWorkerAcceptance(this.request);
    this.dialog = false;
    if (WorkerAnonModule.isError) {
       this.$router.push({ name: PageNames.WorkerError });
    }
  }
}
